import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as modificationSouscriptionFormNames from "./modificationSouscriptionFormNames";

export const modificationSouscriptionValidationSchema = Yup.object().shape({
  [modificationSouscriptionFormNames.VALIDITE_DU_FORM_NAME]:
    Yup.date().typeError(FIELD_STRING),
  [modificationSouscriptionFormNames.VALIDITE_AU_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [modificationSouscriptionFormNames.SOLDE_SUPLEMENTAIRE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [modificationSouscriptionFormNames.SOUSCRIPTION_SUSPENDU_FORM_NAME]:
    Yup.boolean().typeError(FIELD_STRING),
  [modificationSouscriptionFormNames.MOTIF_MODIFICATION_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
});
